var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.getIsInAlert())?_c('alert-modal'):_vm._e(),(_vm.getLoader())?_c('loader'):_vm._e(),_c('v-main',{staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"height":"100%"}},[_c('router-view'),(_vm.getShowCommentEventModal())?_c('comment-event-modal'):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }